import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const CUSTOMERS = collection(db, "customers");

// ── Admin listens to ALL customers live ───────────────────────
// List updates instantly when new customer is added
export function listenToCustomers(callback) {
  const q = query(CUSTOMERS, orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    const customers = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));
    callback(customers);
  });
}

// ── Admin adds a new customer manually ───────────────────────
export async function addCustomer(data) {
  try {
    const ref = await addDoc(CUSTOMERS, {
      ...data,
      status:    "Active",
      orders:    0,
      spent:     0,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return { success: true, docId: ref.id };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Admin updates customer details ────────────────────────────
export async function updateCustomer(docId, data) {
  try {
    await updateDoc(doc(db, "customers", docId), {
      ...data,
      updatedAt: serverTimestamp(),
    });
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Admin deletes a customer ──────────────────────────────────
export async function deleteCustomer(docId) {
  try {
    await deleteDoc(doc(db, "customers", docId));
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}

// ── Auto-create customer when they make first booking ─────────
// Called from BookingModal after order is created
export async function createCustomerFromBooking(formData) {
  try {
    const ref = await addDoc(CUSTOMERS, {
      name:      formData.name,
      email:     formData.email     || "",
      phone:     formData.phone,
      address:   formData.address,
      status:    "Active",
      orders:    1,
      spent:     0,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return { success: true, docId: ref.id };
  } catch (err) {
    return { success: false, error: err.message };
  }
}